import { render, staticRenderFns } from "./TempConfigMaterialModal.vue?vue&type=template&id=4dd9cf4c&scoped=true"
import script from "./TempConfigMaterialModal.vue?vue&type=script&lang=js"
export * from "./TempConfigMaterialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd9cf4c",
  null
  
)

export default component.exports